<!--
 * @Author: Mr.Cong Wei
 * @Date: 2022-12-12 16:58:48
 * @LastEditTime: 2022-12-12 17:11:05
-->
<template>
  <div style="position: relative; width: 20px; height: 20px">
    <svg
      version="1.1"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="20px"
      height="20px"
      xmlns="http://www.w3.org/2000/svg"
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
    >
      <g transform="matrix(1 0 0 1 -457 -259 )">
        <path
          d="M 467 259  C 472.6 259  477 263.4  477 269  C 477 274.6  472.6 279  467 279  C 461.4 279  457 274.6  457 269  C 457 263.4  461.4 259  467 259  Z "
          fill-rule="nonzero"
          fill="#006ab2"
          stroke="none"
        />
        <path
          d="M 467 259.5  C 472.32 259.5  476.5 263.68  476.5 269  C 476.5 274.32  472.32 278.5  467 278.5  C 461.68 278.5  457.5 274.32  457.5 269  C 457.5 263.68  461.68 259.5  467 259.5  Z "
          stroke-width="1"
          stroke="#ffffff"
          fill="none"
        />
      </g>
    </svg>
    <span
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      style="color: #fff"
    >
      主
    </span>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
